var _defs, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQNav3Selected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-q-nav-3-selected{fill:#fff;}.cls-2-q-nav-3-selected{fill:#33b0ce;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lifestyle-PB-02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-q-nav-3-selected",
    cx: 17,
    cy: 17,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-q-nav-3-selected",
    cx: 17,
    cy: 17,
    r: 15.59
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix_Shape_sp-1119-0-0-2",
    "data-name": "prefix  Shape sp-1119-0-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-3-selected",
    d: "M15.34,25.65a1.69,1.69,0,0,1-.7-.15.62.62,0,0,1-.17-.11c-.27-.22-.75-.6-.57-1.15l1.54-5-4,0a1,1,0,0,1-1-1.07,1.09,1.09,0,0,1,.22-.63c.78-1,1.49-2,2.18-2.93s1.41-2,2.2-3,1.54-1.93,2.33-2.9a.65.65,0,0,1,.18-.15,1.55,1.55,0,0,1,1.52,0l.11.08c.25.21.71.61.53,1.16L18.19,14.4l4,0a1.74,1.74,0,0,1,1.07.48.92.92,0,0,1,.3.66c0,.2,0,.36,0,.56a.68.68,0,0,1-.13.39c-1.49,2-3.08,3.9-4.62,5.79l-.48.58c-.64.77-1.28,1.55-1.95,2.38a.55.55,0,0,1-.18.16A1.8,1.8,0,0,1,15.34,25.65Zm-.11-1.32a.39.39,0,0,0,.24,0l1.86-2.28.43-.52c1.53-1.87,3.07-3.75,4.5-5.62v-.14a.38.38,0,0,0-.12,0l-4.85,0a.65.65,0,0,1-.53-.27.67.67,0,0,1-.09-.58l1.7-5.2h-.1L16,12.42c-.77,1-1.47,1.95-2.15,2.9S12.66,17,12,17.9l4.32,0a.68.68,0,0,1,.53.26.66.66,0,0,1,.09.58l-1.7,5.57Zm6.9-8.62Zm.12-.15v0ZM18.46,9.37Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQNav3Selected);
export default __webpack_public_path__ + "static/media/q_nav_3_selected.4b0cd808.svg";
export { ForwardRef as ReactComponent };